//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        props: {
            type: Object,
            default: () => ({
                name: 'certname',
                id: 'certb64'
            })
        }
    },
    data () {
        return {

        }
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(n) {
                this.$emit('input', n);
            }
        },
        isIE() {
            return window.ActiveXObject !== undefined;
        }
    },
    methods: {
        caReadHandler() {
            new Chain().link(function (that, next) {
                hebcaWebSealInit(next);
            }).link(function (that, next) {
                SelectSignCert(function(){
                    next();
                });
            }).link(function (that, next) {
                UILogin(function(){
                    next();
                });
            }).link(function (that, next) {
                GetCertB64(function(certb64){
                    that.model[that.props.id] = certb64;
                    next();
                });
            }).link(function (that, next) {
                GetSubjectItem(0, function(certname){
                    that.model[that.props.name] = certname;
                    next();
                });
            }).link(function (that, next) {
                that.$emit('read', that.model);
                next();
            }).link(function (that, next) {
                try {
                    Logout(function() {
                        next();
                    }.bind(that));
                } catch (e) {
                    next();
                }
            }).run(this);
        },
    },
    mounted: function() {

    }
}
